export default __webpack_public_path__ + "static/media/newFacilitatorListSample.d67b7d24.csv";